import { createContext } from 'react';

export const ApplicationFormContext = createContext();
